import { createFileRoute } from '@tanstack/react-router'
import { LoadingDocumentEditContent } from '@/components/loading-ui/LoadingDocument'
import { StepsContent } from '@/components/document-edit/StepsContent'
import { memo } from 'react'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/projects/$projectId/sops/$sopId/steps',
)({
  component: memo(StepsContent),
  pendingComponent: () => <LoadingDocumentEditContent />,
})
